import { render, staticRenderFns } from "./codeRuleModal.vue?vue&type=template&id=ef65735e"
import script from "./codeRuleModal.vue?vue&type=script&lang=js"
export * from "./codeRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports